import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '/styles/pstlandingpage.module.scss'
import { Button } from "react-bootstrap";
import CustomImage from "../CustomImage"; 
import router from "next/router";
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";

interface Props {
    eventData: any;
}
const CapabilitiesCourseFinder: React.FC<Props> = ({ eventData }) => {
    const courseFinder = eventData.courseFinder || eventData.coursefinder;
    const { zipmeLink, generateLink } = useZipmeLink();
    return (
        <>
            <div className={styles.capabilityBg} style={{ backgroundColor: courseFinder?.sectionBgColor || "#FEF7EE" }}>
                <Container>
                    <Row className="text-center">
                        <div className={styles.heading}>
                            <h2>{ eventData.techCapabilityTitle || 'Technological Capabilities' }</h2>
                            <p>{ eventData.techCapabilitySubTitle || 'An all-in-one platform that supports every step of the recruitment process, to make faster and smarter.' }</p>
                        </div>
                    </Row>
                    <Row className={styles.imgRow}>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                            <div className={styles.content}>
                                <h3>{ courseFinder?.title }</h3>
                                <p>{ courseFinder?.description }</p>
                            </div>
                            <div>
                                {
                                    courseFinder?.points?.length > 0 &&
                                    courseFinder.points.map((text: any) => {
                                        return (
                                            <div className={styles.subcontent}>
                                                <h4>{text.title}</h4>
                                                <p>{text.description}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div>
                                <Button onClick={() => {
                                    !eventData.meta?.jotforms[0]?.jotformid && generateLink(eventData.externalLink)
                                }}
                                    className={`${isFrappeOrJotFormClass(eventData.meta?.jotforms[0]?.jotformid)}`} >
                                    { courseFinder?.button?.label || 'Enquire Now' }
                                </Button>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12} >
                            <div className={styles.imgDiv} >
                                <CustomImage src={courseFinder?.imagePath || "/images/partners/partner1.svg"} alt={courseFinder?.imageAltTag} height={480} width={600} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    )
}
export default CapabilitiesCourseFinder;